import React from "react";
import "./report.css";

export default function ArtVerseReport() {
  return (
    <div className="report-container">
      <h1>ArtVerse: Cross-Platform WebXR Collaboration System</h1>

      <pre className="report-text">
        {`ArtVerse (also known as Art Gallery Metaverse) is a full-stack, cross-platform WebXR system designed to revolutionize digital art exhibition through immersive and interactive collaboration.

FRONTEND IMPLEMENTATION
• Built entirely with A-Frame and Networked A-Frame to create WebXR-compliant 3D environments accessible directly through browsers — no installation required.
• Implemented customizable avatars, real-time 3D scene interaction, and synchronized collaboration where user actions (movement, reactions, artwork edits) are instantly reflected for all participants.
• Optimized WebGL rendering through lightweight 3D assets, texture compression, asynchronous loading, and Level of Detail (LOD) to ensure smooth performance on PCs, mobiles, and VR headsets.
• Designed intuitive UI/UX for non-technical users, including an avatar selection interface and guided interactions for uploading and displaying artwork.

BACKEND IMPLEMENTATION
• Developed a scalable backend infrastructure to handle real-time communication, session management, and data persistence.
• Implemented WebSocket servers to manage multiuser interactions such as avatar movement, chat, and dynamic scene updates with minimal latency.
• Integrated a database for user authentication and session tracking, supported by Redis caching to store frequently accessed state and interaction data.
• Architected for horizontal scalability and fault tolerance with load balancing and failover mechanisms to maintain consistent performance under high concurrency.

NETWORK & INFRASTRUCTURE
• Separated static and dynamic content delivery using HTTP/CDN for assets and WebSocket for real-time events, improving efficiency and response times.
• Designed network communication flow to minimize latency, ensuring synchronized updates across distributed clients in the virtual gallery.

USABILITY AND IMPACT
• Conducted a structured usability study with 15 participants across varying XR experience levels.
• Achieved a 4.8/5 average usability score for navigation, with 73% of participants rating overall satisfaction 5/5.
• Demonstrated the system’s robustness, low latency, and inclusivity across multiple device platforms.

FUTURE EXTENSIONS
• Planned enhancements include AI-guided virtual tours, gamified milestones, and personalized avatar and environment customization.
• Further optimization for large-scale deployment and deeper integration of social and educational use cases within the metaverse.

ArtVerse successfully blends art and technology into a global, collaborative, and immersive digital experience, setting a foundation for future WebXR innovation.`}
      </pre>
    </div>
  );
}
